import React from "react";
import { connect } from "react-redux";
import { Text } from "ui-components";

import RiskSelectorList from "@workerhome/components/Content/RiskSelectorList";
import AppendixDialog from "@common/components/AppendixDialog";
import RiskSectionInfo from "@common/components/RiskSectionInfo";
import Comment from "@common/components/Comment";
import {
  updateComment,
  toggleDialog,
  toggleAppendixTip,
  toggleSuggestedTip,
  upsertSuggestedTip,
  deleteSuggestedTip
} from "@workerhome/components/App/actions";
import { LayoutWrapper, LayoutHeader, LayoutBody } from "@common/styled/layout";

class Assessment extends React.Component {
  /**
   * Update the section comment
   * @param  {object} event Change event object
   */
  doUpdateComment = event => {
    const newComment = event.target.value;
    const subSectionIdx = this.props.stepsMeta.activeSubStep;

    this.props.updateComment(newComment, subSectionIdx);
  };

  /**
   * Hide the Appendix Dialog
   */
  toggleAppendixDialog = () => {
    this.props.toggleDialog("Appendix", false);
  };

  render() {
    // Get the current subsection
    const { section, stepsMeta } = this.props;
    const currentSubSection = section.subsections[stepsMeta.activeSubStep];

    return (
      <LayoutWrapper>
        <LayoutHeader backgroundColor="whiteGrey">
          <Text size={4} type="bold">
            Assessment Item
          </Text>
        </LayoutHeader>
        <LayoutBody>
          <RiskSelectorList sectionKey={currentSubSection.key}>
            {currentSubSection.risks}
          </RiskSelectorList>
          <AppendixDialog
            title={null}
            subsectionIdx={stepsMeta.activeSubStep}
            isShown={this.props.isAppendixDialogShown}
            toggleDialog={this.toggleAppendixDialog}
            section={currentSubSection}
            onAppendixTipClick={this.props.onAppendixTipClick}
            onSuggestedTipClick={this.props.onSuggestedTipClick}
            upsertSuggestedTip={this.props.upsertSuggestedTip}
            deleteSuggestedTip={this.props.deleteSuggestedTip}
          />
          <RiskSectionInfo
            suggestedTips={currentSubSection.suggestedTips}
            checkedAppendixTips={currentSubSection.checkedAppendixTips}
          />
          <Comment
            value={currentSubSection.comment}
            onBlur={this.doUpdateComment}
          />
        </LayoutBody>
      </LayoutWrapper>
    );
  }
}

function mapStateToProps(store) {
  return {
    section: store.workerHome.app,
    stepsMeta: store.workerHome.sidebar.stepsMeta,
    isAppendixDialogShown: store.workerHome.app.ui.isAppendixDialogShown
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateComment: (newComment, subSectionIdx) => {
      dispatch(updateComment(newComment, subSectionIdx));
    },
    toggleDialog: (dialog, isShown) => dispatch(toggleDialog(dialog, isShown)),
    onAppendixTipClick: tipInfo => dispatch(toggleAppendixTip(tipInfo)),
    onSuggestedTipClick: tipInfo => dispatch(toggleSuggestedTip(tipInfo)),
    upsertSuggestedTip: tipInfo => dispatch(upsertSuggestedTip(tipInfo)),
    deleteSuggestedTip: tipInfo => dispatch(deleteSuggestedTip(tipInfo))
  };
}

const AssessmentContainer = connect(mapStateToProps, mapDispatchToProps)(
  Assessment
);
export default AssessmentContainer;



// WEBPACK FOOTER //
// ./src/workerhome/components/Content/Layouts/AssessmentContainer.jsx